import renderHTML from "react-render-html";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";

const TermsAndCondition = ({ state, onclick, body }) => {
  return (
    <Dialog
      open={state}
      onClose={() => onclick()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"lg"}
      fullScreen={true}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box m={1}>
            <Typography variant="body2">
              <small>{body ? renderHTML(body) : ""}</small>
            </Typography>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant={"contained"}
          size={"small"}
          onClick={() => onclick()}
          color="secondary"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndCondition;
